import { DefaultQueryParams, PaginatedResponse } from '@frontend/api-utils';

export interface Budget {
    name: string;
    type: BudgetType;
    from_timestamp: string;
    to_timestamp: string;
    update_timestamp: string;
    id: string;
    account_id: string;
    creation_timestamp: string;
}

export interface CreateBudget {
    name: string;
    type?: BudgetType | null;
    from_timestamp?: string;
    to_timestamp?: string;
}

export interface UpdateBudget {
    name?: string | null;
    type?: BudgetType | null;
    from_timestamp?: string;
    to_timestamp?: string;
}

export enum BudgetType {
    REPLENISHMENT = 'replenishment',
    CONSUMPTION = 'consumption'
}

enum QueryParams {
    ACCOUNT_ID = 'account_id',
}
export type BudgetQueryParams = DefaultQueryParams | QueryParams
export type BudgetListResponse = PaginatedResponse<Budget>;
